import { render } from "./mainCategory.vue?vue&type=template&id=d875bbc6&scoped=true"
import script from "./mainCategory.vue?vue&type=script&lang=js"
export * from "./mainCategory.vue?vue&type=script&lang=js"

import "./mainCategory.vue?vue&type=style&index=0&id=d875bbc6&lang=scss&scoped=true"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d875bbc6"]])

export default __exports__